import { GET_SERVICES_RESPONSE, GET_SERVICE_DETAILS_RESPONSE } from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  serviceDetails: null,
};

const services = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SERVICES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case GET_SERVICE_DETAILS_RESPONSE:
      return {
        ...state,
        serviceDetails: action.payload.serviceDetails,
      };
    default:
      return state;
  }
};

export default services;
